import React from 'react';

export const renderCallTypeActivityIcon = ({item}: any) => {
    return item?.callType === 'transferInternal' && !item.isDeclined ? (
        <div className="relative">
            <i className="pi pi-reply p-2 bg-green-500 border-circle text-white"
               style={{transform: 'rotate(90deg) scaleX(1) scaleY(-1)'}}></i>
        </div>
    ) : item?.callType === 'transferInternal' && item.isDeclined ? (
        <div className="relative">
            <i className="pi pi-reply p-2 bg-green-500 border-circle text-white"
               style={{transform: 'rotate(90deg) scaleX(1) scaleY(-1)'}}></i>
            <div className="absolute" style={{top: '-5px', left: '18px'}}>
                <div className="border-circle relative"
                     style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                    <i className="pi pi-times text-white absolute left-50 top-50 kk"
                       style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                </div>
            </div>
        </div>
    ) : item?.callType === 'transferExternal' && !item.isDeclined ? (
        <div className="relative">
            <i className="pi pi-reply p-2 bg-primary border-circle text-white"
               style={{transform: 'rotate(90deg) scaleX(-1) scaleY(-1)'}}></i>
        </div>
    ) : item?.callType === 'callbackExternal' && !item.isDeclined ? (
        <div className="relative">
            <i className="pi pi-undo p-2 border-circle text-white"
               style={{background: 'rgb(253, 166, 16)'}}></i>
            <div className="absolute" style={{top: '-5px', left: '18px'}}>
                <div className="border-circle relative bg-primary"
                     style={{width: '14px', height: '14px'}}>
                    <i className="pi pi-arrow-up-right text-white absolute left-50 top-50 kk"
                       style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                </div>
            </div>
        </div>
    ) : item?.callType === 'callbackInternal' && !item.isDeclined ? (
        <div className="relative">
            <i className="pi pi-undo p-2 border-circle text-white"
               style={{background: 'rgb(253, 166, 16)'}}></i>
            <div className="absolute" style={{top: '-5px', left: '18px'}}>
                <div className="border-circle relative bg-green-500"
                     style={{width: '14px', height: '14px'}}>
                    <i className="pi pi-arrow-down-left text-white absolute left-50 top-50 kk"
                       style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                </div>
            </div>
        </div>
    ) : (item?.callType === 'callbackInternal' || item?.callType === 'callbackExternal') && item.isDeclined ? (
        <div className="relative">
            <i className="pi pi-undo p-2 border-circle text-white"
               style={{background: 'rgb(253, 166, 16)'}}></i>
            <div className="absolute" style={{top: '-5px', left: '18px'}}>
                <div className="border-circle relative"
                     style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                    <i className="pi pi-times text-white absolute left-50 top-50 kk"
                       style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                </div>
            </div>
        </div>
    ) : item?.callType === 'callback' ? (
        <div className="relative">
            <i className="pi pi-undo p-2 border-circle text-white" style={{backgroundColor: "#fda610"}}></i>
        </div>
    ) : item?.callType === 'internal' && !item.isDeclined ? (
        <div className="relative">
            <i className="pi pi-arrow-down-left p-2 border-circle bg-green-500 text-white"></i>
        </div>
    ) : item?.callType === 'internal' && item.isDeclined ? (
        <div className="relative">
            <i className="pi pi-arrow-down-left p-2 border-circle bg-green-500 text-white"></i>
            <div className="absolute" style={{top: '-5px', left: '18px'}}>
                <div className="border-circle relative"
                     style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                    <i className="pi pi-times text-white absolute left-50 top-50 kk"
                       style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                </div>
            </div>
        </div>
    ) : item?.callType === 'external' && !item.isDeclined ? (
        <>
            <i className="pi pi-arrow-up-right bg-primary p-2 border-circle text-white"></i>
        </>
    ) : item?.callType === 'ivm' && !item.isDeclined ? (
        <>
            <i className="bg-primary p-2 border-circle text-white font-bold relative"
               style={{fontStyle: "normal", width: '27.99px', height: '27.99px'}}><span
                className="absolute"
                style={{left: '50%', top: '50%', transform: 'translate(-50%, -50%)', fontSize: '11px'}}>IVM</span></i>
        </>
    ) : item?.callType === 'ivm' && item.isDeclined ? (
        <div className="relative inline-block">
            <i className="bg-primary border-circle text-white font-bold relative inline-flex align-items-center justify-content-center"
               style={{fontStyle: "normal", width: '28px', height: '28px', minWidth: '28px', minHeight: '28px', borderRadius: '50%'}}><span
                style={{fontSize: '11px'}}>IVM</span></i>
            <div className="absolute" style={{top: '-3px', right: '-3px'}}>
                <div className="border-circle relative"
                     style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                    <i className="pi pi-times text-white absolute left-50 top-50 kk"
                       style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                </div>
            </div>
        </div>
    ) : item?.callType === 'ivr' && !item.isDeclined ? (
        <>
            <i className="bg-green-500 p-2 border-circle text-white font-bold relative"
               style={{fontStyle: "normal", width: '27.99px', height: '27.99px'}}><span
                className="absolute"
                style={{left: '50%', top: '50%', transform: 'translate(-50%, -50%)', fontSize: '11px'}}>IVR</span></i>
        </>
    ) : item?.callType === 'ivr' && item.isDeclined ? (
        <div className="relative inline-block">
            <i className="bg-green-500 border-circle text-white font-bold relative inline-flex align-items-center justify-content-center"
               style={{fontStyle: "normal", width: '28px', height: '28px', minWidth: '28px', minHeight: '28px', borderRadius: '50%'}}><span
                style={{fontSize: '11px'}}>IVR</span></i>
            <div className="absolute" style={{top: '-3px', right: '-3px'}}>
                <div className="border-circle relative"
                     style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                    <i className="pi pi-times text-white absolute left-50 top-50 kk"
                       style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                </div>
            </div>
        </div>
    ) : item?.callType === 'external' && item.isDeclined ? (
        <div className="relative">
            <i className="pi pi-arrow-up-right bg-primary p-2 border-circle text-white"></i>
            <div className="absolute" style={{top: '-5px', left: '18px'}}>
                <div className="border-circle relative"
                     style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                    <i className="pi pi-times text-white absolute left-50 top-50 kk"
                       style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                </div>
            </div>
        </div>
    ) : item?.callType === 'consultation' && !item.isDeclined ? (
        <div className="relative">
            <i className="pi pi-users p-2 border-circle text-white" style={{background: 'rgb(253, 166, 16)'}}></i>
        </div>
    ) : item?.callType === 'consultation' && item.isDeclined ? (
        <div className="relative">
            <i className="pi pi-users p-2 border-circle text-white"
               style={{background: 'rgb(253, 166, 16)'}}></i>
            <div className="absolute" style={{top: '-5px', left: '18px'}}>
                <div className="border-circle relative"
                     style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                    <i className="pi pi-times text-white absolute left-50 top-50 kk"
                       style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                </div>
            </div>
        </div>
    ) : item?.callType === 'consultationExternal' && !item.isDeclined ? (
        <div className="relative">
            <i className="pi pi-users p-2 border-circle text-white"
               style={{background: 'rgb(253, 166, 16)'}}></i>
            <div className="absolute" style={{top: '-5px', left: '18px'}}>
                <div className="border-circle relative bg-primary"
                     style={{width: '14px', height: '14px'}}>
                    <i className="pi pi-arrow-up-right text-white absolute left-50 top-50 kk"
                       style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                </div>
            </div>
        </div>
    ) : item?.callType === 'consultationInternal' && !item.isDeclined ? (
        <div className="relative">
            <i className="pi pi-users p-2 border-circle text-white"
               style={{background: 'rgb(253, 166, 16)'}}></i>
            <div className="absolute" style={{top: '-5px', left: '18px'}}>
                <div className="border-circle relative bg-green-500"
                     style={{width: '14px', height: '14px'}}>
                    <i className="pi pi-arrow-down-left text-white absolute left-50 top-50 kk"
                       style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                </div>
            </div>
        </div>
    ) : (item?.callType === 'consultationInternal' || item?.callType === 'consultationExternal') && item.isDeclined ? (
        <div className="relative">
            <i className="pi pi-users p-2 border-circle text-white"
               style={{background: 'rgb(253, 166, 16)'}}></i>
            <div className="absolute" style={{top: '-5px', left: '18px'}}>
                <div className="border-circle relative"
                     style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                    <i className="pi pi-times text-white absolute left-50 top-50 kk"
                       style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                </div>
            </div>
        </div>
    ) : (item?.callType === 'pickupcall') && item.isDeclined ? (
        <div className="relative">
            <i className="pi pi-user p-2 border-circle text-white"
               style={{background: 'rgb(253, 166, 16)'}}></i>
            <div className="absolute" style={{top: '-5px', left: '18px'}}>
                <div className="border-circle relative"
                     style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                    <i className="pi pi-times text-white absolute left-50 top-50 kk"
                       style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                </div>
            </div>
        </div>
    ) : item?.callType === 'pickupcall' && !item.isDeclined ? (
        <div className="relative">
            <i className="pi pi-user p-2 border-circle text-white" style={{background: 'rgb(253, 166, 16)'}}></i>
        </div>
    ) : (item?.callType === 'spycall') && item.isDeclined ? (
        <div className="relative">
            <i className="pi pi-headphones p-2 border-circle text-white"
               style={{background: 'rgb(253, 166, 16)'}}></i>
            <div className="absolute" style={{top: '-5px', left: '18px'}}>
                <div className="border-circle relative"
                     style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                    <i className="pi pi-times text-white absolute left-50 top-50 kk"
                       style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                </div>
            </div>
        </div>
    ) : item?.callType === 'spycall' && !item.isDeclined ? (
        <div className="relative">
            <i className="pi pi-headphones p-2 border-circle text-white" style={{background: 'rgb(253, 166, 16)'}}></i>
        </div>
    ) : <></>;
};
